import React from 'react';
import { Avatar as MaterialAvatar, AvatarProps } from '@material-ui/core';

export const Avatar: React.FC<AvatarProps> = ({ children, ...props }) => {
  return <MaterialAvatar {...props}>{children}</MaterialAvatar>;
};
